(() => {
  'use strict';

  const dialog = document.querySelector('[data-mx-vintage-week]');
  if (!dialog || dialog.dataset.designMode === 'true' || typeof dialog.showModal !== 'function') return;

  const SESSION_KEY = 'maximilian:vintage-week:2026:shown';
  const EVENT_START = Date.parse('2026-08-19T00:00:00-04:00');
  const EVENT_END = Date.parse('2026-08-23T00:00:00-04:00');
  const now = Date.now();

  if (now < EVENT_START || now >= EVENT_END) return;

  let session;
  try {
    session = window.sessionStorage;
    if (session.getItem(SESSION_KEY) === '1') return;
  } catch (error) {
    return;
  }

  const closeButton = dialog.querySelector('[data-mx-vintage-week-close]');
  const priorFocus = document.activeElement;
  let coexistenceTimer;

  const visibleCompetingModal = () =>
    Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(
      (element) => element !== dialog && element.getClientRects().length > 0
    );

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  closeButton?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog.addEventListener('close', () => {
    if (coexistenceTimer) window.clearInterval(coexistenceTimer);
    if (priorFocus instanceof HTMLElement && priorFocus.isConnected) priorFocus.focus();
  });

  let attempts = 0;
  const openWhenClear = () => {
    attempts += 1;
    if (visibleCompetingModal()) {
      if (attempts < 20) window.setTimeout(openWhenClear, 1500);
      return;
    }

    try {
      session.setItem(SESSION_KEY, '1');
    } catch (error) {
      return;
    }

    dialog.showModal();
    closeButton?.focus();
    coexistenceTimer = window.setInterval(() => {
      if (!dialog.open) {
        window.clearInterval(coexistenceTimer);
      } else if (visibleCompetingModal()) {
        closeDialog();
      }
    }, 750);
  };

  window.setTimeout(openWhenClear, 1500);
})();
